<template>
  <el-dialog
    title="管理模版"
    :visible.sync="dialogVisible"
    width="600px"
  >
    <div>
      <el-table
        :data="templateList"
        style="width: 100%"
      >
        <el-table-column prop="title" label="名称"  mine-width="200px"></el-table-column>
        <el-table-column label="操作" width="130px">
          <template slot-scope="scope">
            <el-button type="text" @click="previewTemplate(scope.row)">预览</el-button>
            <el-button type="text" @click="deleteTemplate(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="close">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    templateList: {
      type: Array,
      required: true,
      default() {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(newVal) {
        this.$emit('update:visible', newVal)
      }
    }
  },
  methods: {
    close() {
      this.dialogVisible = false
    },
    previewTemplate({ id }) {
      const routeData = this.$router.resolve({
        path: `/approval/viewForm`,
        query: { 
          type: 'templateDetail',
          templateId: id,
          _raw: 1
        }
      })
      window.open(routeData.href, '_blank');
    },
    deleteTemplate({ id }) {
      this.$confirm('此操作将永久删除该模版, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('deleteTemplate', id)
      })
    }
  },
}
</script>

<style>

</style>